class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  }

  connectedCallback() {
    const navigation = this.closest('.header__inline-menu');
    if (!navigation) return;

    this.hoverEvents = new AbortController();
    const options = { signal: this.hoverEvents.signal };
    this.categoryLink = this.querySelector('.kw-header-category__link');
    this.categoryLink?.addEventListener('focusout', this.onFocusOut.bind(this), options);
    this.addEventListener('pointerenter', this.onPointerEnter.bind(this), options);
    this.addEventListener('pointerleave', this.onPointerLeave.bind(this), options);
    navigation.addEventListener('pointerover', this.onNavigationPointerOver.bind(this), options);
    this.addEventListener('keydown', (event) => {
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        (this.categoryLink || summary).focus();
        return;
      }
      if (![summary, this.categoryLink].includes(event.target) || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      this.mainDetailsToggle.open = true;
      summary.setAttribute('aria-expanded', 'true');
      const links = this.content.querySelectorAll('a[href]');
      (event.key === 'ArrowUp' ? links[links.length - 1] : links[0])?.focus();
    }, options);
    document.addEventListener('pointerdown', (event) => {
      if (!this.contains(event.target)) this.close();
    }, options);
  }

  disconnectedCallback() {
    this.hoverEvents?.abort();
    clearTimeout(this.closeTimer);
  }

  canHover(event) {
    return event.pointerType === 'mouse' && this.hoverMedia.matches;
  }

  onPointerEnter(event) {
    if (!this.canHover(event)) return;
    clearTimeout(this.closeTimer);
    this.mainDetailsToggle.open = true;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onPointerLeave(event) {
    if (!this.canHover(event)) return;
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 180);
  }

  onNavigationPointerOver(event) {
    if (!this.canHover(event)) return;
    const item = event.target.closest('.header__inline-menu > ul > li');
    if (item && !item.contains(this)) this.close();
  }

  close() {
    clearTimeout(this.closeTimer);
    super.close();
    this.categoryLink?.setAttribute('aria-expanded', 'false');
  }

  onToggle() {
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', this.mainDetailsToggle.open);
    this.categoryLink?.setAttribute('aria-expanded', this.mainDetailsToggle.open);
    if (!this.header) return;
    if (this.mainDetailsToggle.open) {
      this.header.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
      this.header.querySelectorAll('predictive-search[open]').forEach((search) => search.close());
    }
    this.header.preventHide = Boolean(this.header.querySelector('header-menu > details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
